import { X } from 'lucide-react';

export type FilterChip = { key: string; label: string; onRemove: () => void };

export const FilterChips: React.FC<{ chips: FilterChip[] }> = ({ chips }) =>
  chips.length === 0 ? null : (
    <div className="flex flex-wrap items-center gap-2" aria-label="Active filters">
      {chips.map((chip) => (
        <span
          key={chip.key}
          className="inline-flex items-center gap-1 rounded-full border border-blue-200 bg-blue-50 py-0.5 pl-3 pr-1 text-xs font-medium text-blue-800"
        >
          {chip.label}
          <button
            type="button"
            onClick={chip.onRemove}
            className="rounded-full p-0.5 hover:bg-blue-100"
            aria-label={`Remove filter ${chip.label}`}
          >
            <X className="h-3 w-3" />
          </button>
        </span>
      ))}
    </div>
  );
